module.exports = __webpack_public_path__ + "media/customizations/trinityfalls/logo-0f3536ee2aaeaacee797c7d756166c33.png";